import snakeCase from 'lodash/snakeCase';
import isNumber from 'lodash/isNumber';
import reduce from 'lodash/reduce';
import isArray from 'lodash/isArray';
import map from 'lodash/map';
import isObjectLike from 'lodash/isObjectLike';

const val2str = (val) => {
  return isNumber(val) ? val.toString() : val;
};

const transformAnalyticsData = (datas) => {
  if (isArray(datas)) {
    return map(datas, (value) => {
      return isObjectLike(value) ? transformAnalyticsData(value) : val2str(value);
    });
  }
  if (isObjectLike(datas)) {
    return reduce(datas, (result, value, key) => {
      const obj = {};
      if (isObjectLike(value)) {
        obj[snakeCase(key)] = transformAnalyticsData(value);
      } else {
        obj[snakeCase(key)] = val2str(value);
      }
      return { ...result, ...obj };
    }, {});
  }
  return datas;
};

export default transformAnalyticsData;
